import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { CommonApiService } from '../CommonController/common-api-service';
import { ProductionDeviceApiService } from '../CommonController/production-device-api-service';

@Component({
  selector: 'app-production-device-page',
  templateUrl: './production-device-page.component.html',
  styleUrls: ['./production-device-page.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    CommonSearchComponent,
    CommonPaginationComponent,
  ],
})
export class ProductionDevicePageComponent implements OnInit {
  // Pagination settings
  pageSize = 10; // Number of items per currentPage
  currentPage = 1; // Current currentPage
  totalItems = 0; // Total number of items (for pagination purposes)
  searchText = ''; // Search text
  productionDeviceList = [];

  productionForm: FormGroup;

  userPermission = [];
  loggedId = '';
  ProductionDeviceView = false;
  ProductionDeviceUpdate = false;
  ProductionDeviceCreate = false;
  ProductionDeviceDelete = false;

  constructor(
    public productionDeviceApiService: ProductionDeviceApiService,
    public commonApiService: CommonApiService,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setProductionForm();
    this.fetchProductionList();
  }

  checkPermission() {
    this.loggedId = sessionStorage.getItem('loggedInUserId');
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermissions'));
    this.userPermission.forEach((element) => {
      if (element.pageName === 'Production Device' && element.view === false) {
        this.navigateBack();
      }
      if (element.pageName === 'Production Device' && element.view === true) {
        this.ProductionDeviceView = true;
      }
      if (element.pageName === 'Production Device' && element.update === true) {
        this.ProductionDeviceUpdate = true;
      }
      if (element.pageName === 'Production Device' && element.create === true) {
        this.ProductionDeviceCreate = true;
      }
      if (element.pageName === 'Production Device' && element.delete === true) {
        this.ProductionDeviceDelete = true;
      }
    });
  }

  setProductionForm() {
    this.productionForm = this.fb.group({
      productionDeviceListSearch: new FormControl(''),
    });
  }

  fetchProductionList() {
    this.spinner.show();
    this.productionDeviceApiService
      .getProductionDeviceList(this.currentPage, this.pageSize, this.searchText)
      .subscribe({
        next: (res) => {
          this.productionDeviceList = res.data;
          this.totalItems = res.totalItems;
          this.commonApiService.openSnackbar(res.message);
          this.spinner.hide();
        },
        error: (error) => {
          this.productionDeviceList = []; // Clear the list
          this.totalItems = 0; // Reset the total count
          this.currentPage = 1;
          this.spinner.hide();
          this.commonApiService.openSnackbar(
            error.error.message || 'An error occurred while fetching data.'
          );
        },
      });
  }

  prepopulation(uid) {
    this.router.navigate(['production-device-add-page', uid]);
  }

  delete(uid) {
    const userId = this.loggedId; // Hardcoded userId
    if (confirm('Are you Sure?')) {
      this.spinner.show();
      this.productionDeviceApiService
        .deleteProductionData(uid, userId)
        .subscribe((res) => {
          if (res.status) {
            this.commonApiService.openSnackbar(res.message);
          } else {
            this.commonApiService.openSnackbar(res.message);
          }
          this.fetchProductionList(); // Refresh list after deletion
          this.spinner.hide();
        });
    }
  }

  AddNew() {
    this.router.navigate(['production-device-add-page']);
  }

  AddNewExcel() {
    this.router.navigate(['production-device']);
  }

  onPageChange(event) {
    this.currentPage = event;
    this.fetchProductionList();
  }

  onSearchInputChange(event) {
    this.currentPage = 1;
    this.searchText = event;
    this.fetchProductionList();
  }

  onSizeChange(newSize): void {
    this.pageSize = newSize; // Update the pageSize
    this.currentPage = 1; // Reset to the first currentPage
    this.fetchProductionList();
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  navigateBack() {
    this.commonApiService.back();
  }
}
